import React from 'react'

import { Text, Icon, Dialog, Heading } from '@plurall/elo-beta'

import styles from './AccessCode.module.css'

import { isMobile } from 'utils'

const dialogTypes = {
  positive: 'Check-circle',
  negative: 'Cancel-circle',
  informative: 'Exclamation-circle',
}

const AccessCodeDialog = ({ dialog, codeInfo, errorStore, navigate, dismiss }) => {
  const hasEmptyTradeName = codeInfo?.tradeName === ''
  const hasErrorStore = !!errorStore?.error?.errorMessage

  const dialogTitle = (type, title) => (
    <div className={styles.dialogTitle}>
      <Icon size='big' variant={type} secondary type={dialogTypes[type]} />
      <Heading element='h4'>{title}</Heading>
    </div>
  )

  const renderSuccessCodeMessage = data => {
    const { title, tradeName, legalName } = data

    if (tradeName || hasEmptyTradeName) {
      const schoolName = hasEmptyTradeName ? legalName : tradeName
      return `Sua conta foi vinculada a escola ${schoolName}. Para finalizar, você precisa selecionar uma função.`
    } else {
      return `O material ${title} está acessível em Cadernos digitais.`
    }
  }

  const renderDialog = () => {
    const { type, message, title } = dialog
    const validateBehavior = (codeInfo?.tradeName || hasEmptyTradeName) && !hasErrorStore

    return (
      <div className={styles.dialogWidth}>
        <Dialog
          title={dialogTitle(type, title)}
          size={!isMobile() && 'small'}
          secondaryButtonText={validateBehavior ? 'Selecionar função' : 'Fechar'}
          onSecondaryClick={validateBehavior ? navigate : dismiss}
          clickOutside={false}
          onClose={dismiss}
        >
          <Text size='t3'>{message || renderSuccessCodeMessage(codeInfo)}</Text>
        </Dialog>
      </div>
    )
  }

  return renderDialog()
}

export default AccessCodeDialog
